import { useState, useEffect, useCallback } from "react";

const useSlider = (totalSlides, autoPlayInterval = 4000) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    const nextSlide = useCallback(() => {
        setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, [totalSlides]);

    const goToSlide = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    useEffect(() => {
        if (!isPaused) {
            const interval = setInterval(nextSlide, autoPlayInterval);
            return () => clearInterval(interval);
        }
    }, [nextSlide, isPaused, autoPlayInterval]);

    return {
        currentIndex,
        nextSlide,
        goToSlide,
        setIsPaused,
    };
};

export default useSlider;
